import Tablet from '@material-ui/icons/Tablet';
import OrderList from './list';
import ShowOrder from './show';

export default {
  list: OrderList,
  show: ShowOrder,
  icon: Tablet,
};
